import { motion, type HTMLMotionProps } from "framer-motion";
import { Link, type To } from "react-router-dom";
import type { ButtonHTMLAttributes } from "react";
import clsx from "clsx";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost";
  size?: "sm" | "md" | "lg";
  loading?: boolean;
  to?: To;
}

export function Button({
  className = "",
  variant = "primary",
  size = "md",
  loading = false,
  to,
  children,
  ...props
}: ButtonProps) {
  const classes = clsx(
    "button",
    `button-${variant}`,
    `button-${size}`,
    loading && "button-loading",
    className
  );

  const buttonContent = (
    <span className="button-content">
      {children}
    </span>
  );

  if (to) {
    return (
      <Link to={to} className={classes}>
        {buttonContent}
      </Link>
    );
  }

  if (variant === "ghost") {
    return (
      <motion.button
        className={classes}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        disabled={loading}
        {...(props as HTMLMotionProps<"button">)}
      >
        {buttonContent}
      </motion.button>
    );
  }

  return (
    <button 
      className={classes}
      disabled={loading}
      {...props}
    >
      {buttonContent}
    </button>
  );
} 